/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Unarchive_ErrorInputs */

const fr_vehicle_action_unarchive_error = /** @type {(inputs: Vehicle_Action_Unarchive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors du désarchivage du véhicule.`)
};

const en_vehicle_action_unarchive_error = /** @type {(inputs: Vehicle_Action_Unarchive_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while unarchiving the vehicle.`)
};

/**
* | output |
* | --- |
* | "An error occurred while unarchiving the vehicle." |
*
* @param {Vehicle_Action_Unarchive_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_unarchive_error = /** @type {((inputs?: Vehicle_Action_Unarchive_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Unarchive_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_unarchive_error(inputs)
	return en_vehicle_action_unarchive_error(inputs)
});